import React, { useEffect } from 'react';

import PropTypes from 'prop-types';

import amplitude from 'amplitude-js';
import { DangerouslyHtml } from 'apps/auth/components/common/DangerouslyHtml/DangerouslyHtml';
import { InfoPage } from 'apps/auth/components/common/Layout/InfoPage/InfoPage';
import { STATEMENT_SENT_SHOWN } from 'apps/auth/constants/amplitude/AmplitudeEvents';
import { AUTH_SEND_MAIN_LINK } from 'apps/auth/constants/UrlConstants';
import { resolveArguments } from 'apps/auth/helpers/utils';
import { usePageMessages } from 'apps/auth/hooks/selectors';

const StatementSuccessScreen = ({ userEmail }) => {
    const { statementSuccessTitle, statementSuccessText, gotIt } = usePageMessages();

    useEffect(() => {
        amplitude.getInstance().logEvent(STATEMENT_SENT_SHOWN);
    }, []);

    return (
        <>
            <InfoPage
                insideModalComponent
                animatedIconSuccess
                headerText={statementSuccessTitle}
                secondaryText={<DangerouslyHtml dangerouslyHtml={resolveArguments(statementSuccessText, userEmail)} />}
                primaryButtonCaption={gotIt}
                primaryButtonType="link"
                primaryButtonLink={AUTH_SEND_MAIN_LINK}
            />
        </>
    );
};

StatementSuccessScreen.propTypes = {
    userEmail: PropTypes.string,
};

export default StatementSuccessScreen;
